import * as React from 'react';
import Button from '@mui/material/Button';
import ArticleIcon from '@mui/icons-material/Article';
import { Link as RouterLink } from 'react-router-dom';
import { useProjectLink } from '../hooks/useProjectLink';

export default function ProjectBlogButton({ slug }: { slug: string }) {
  const { link, loading } = useProjectLink(slug);
  if (loading || !link) return null;
  return (
    <Button
      component={RouterLink}
      to={`/blog/${link.postId}`}
      startIcon={<ArticleIcon />}
      variant="outlined"
      size="small"
    >
      {link.postTitle}
    </Button>
  );
}
